  <template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    color="indigo"
    dark
  >
    <v-toolbar-title
      style="width: 300px"
      class="ml-0 pl-3"
    >
      <!--<v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>-->
      <v-app-bar-nav-icon @click.stop="updateDrawer"></v-app-bar-nav-icon>
      <span class="hidden-sm-and-down"><!--Galaxie Media--></span>
    </v-toolbar-title>
    <!--
    <v-text-field
      flat
      solo-inverted
      hide-details
      prepend-inner-icon="search"
      label="Search"
      class="hidden-sm-and-down"
    ></v-text-field>
  -->
    <v-spacer></v-spacer>


    <span>

      {{name}}
    </span>
    <v-btn 
      icon
    >
      <v-icon @click="logout">mdi-logout</v-icon>
    </v-btn>
    <!--

    <v-btn icon>
      <v-icon>apps</v-icon>
    </v-btn>
    <v-btn icon>
      <v-icon>notifications</v-icon>
    </v-btn>
    <v-btn
      icon
      large
    >
      <v-avatar
        size="32px"
        item
      >
        <v-img
          src="https://cdn.vuetifyjs.com/images/logos/logo.svg"
          alt="Vuetify"
        >
        </v-img></v-avatar>
    </v-btn>
  -->
  </v-app-bar>
</template>

<script>
export default {
  data : function(){
    return {
      drawer: null,
      name: ''
    }
  },
  created(){
    this.isAuthenticated()
  },
  watch: {
    // Everytime the route changes, check for auth status
    '$route': 'isAuthenticated'
  },
  methods :{
    isAuthenticated(){
      this.$auth.isAuthenticated()
      .then(res =>{
        this.authenticated = res
        if(this.name == '' && res){
          this.$auth.getUser()
          .then(res =>{
            console.log(res)
            if(res )
            this.name = res.name
          })
        }
      })
    },
    updateDrawer(){
      this.$emit('drawerUpdate')
    },
    
    logout(){
      this.$auth.logout()
      this.$router.push('/');
      this.name = '';
    }
  }
}
</script>